import script from "./messagesContent.windows.vue?vue&type=script&setup=true&lang=ts"
export * from "./messagesContent.windows.vue?vue&type=script&setup=true&lang=ts"

import "./messagesContent.windows.vue?vue&type=style&index=0&id=633a60b5&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-633a60b5"]])

export default __exports__